export default function capitalize(string: string) {
  return string.slice(0, 1).toUpperCase() + string.slice(1);
}
